import { type JSX } from 'react';
import { Activity } from 'lucide-react';
import { SidebarNavSection } from './SidebarNavSection';

interface AgentsActivityNavGroupProps {
  /** Route the group (and its single child) navigates to. */
  to: string;
}

/**
 * AgentsActivityNavGroup — the "Agents Activity" sidebar section.
 *
 * Renders the parent row (Activity icon + label + NEW badge) with the
 * "Packages & Repos" page as its single child via {@link SidebarNavSection},
 * so it shares the section highlight behavior (selected child carries the
 * pill, active parent goes full-contrast — KIR-4159). Prompts (a future
 * child) will slot in alongside it.
 */
export function AgentsActivityNavGroup({
  to,
}: AgentsActivityNavGroupProps): JSX.Element {
  return (
    <SidebarNavSection
      label="Agents Activity"
      to={to}
      icon={Activity}
      items={[{ label: 'Packages & Repos', to }]}
      badge={
        <span className="ml-auto rounded-full bg-blue-600 px-1.5 py-0.5 text-[10px] font-bold uppercase leading-none tracking-wide text-white">
          New
        </span>
      }
    />
  );
}
